import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { IdGen } from 'utils'

import * as SedeCrud from 'services/sede.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Establecimientos' }]

const tableHeaderRows = [
  { label: 'NOMBRE' },
  { label: 'DIRECCION' },
  { label: 'TELEFONO', width: 100 },
  { label: 'ANEXO', width: 80 },
  { label: '', width: 60 }
]

const ListaSubMediosPagoPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const tablaRef = React.useRef(null)
  const editarData = React.useRef(null)

  const [mostrarCrearEditarModal, setMostrarCrearEditarModal] = React.useState(false)

  const clickNuevo = React.useCallback(() => {
    editarData.current = {}
    setMostrarCrearEditarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      await SedeCrud.getSede(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarCrearEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await SedeCrud.eliminarSede(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={IdGen.newId()}>
        <Table.Cell>{row.nombre || '--'}</Table.Cell>
        <Table.Cell>{row.direccion || '--'}</Table.Cell>
        <Table.Cell>{row.telefono || '--'}</Table.Cell>
        <Table.Cell>{row.anexo || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Establecimientos' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
        <Portlet.Body>
          <Table.ServerSide useNest={true} ref={tablaRef} url='/sedes' headRows={tableHeaderRows} rowTemplate={rowTemplate} />
        </Portlet.Body>
      </Portlet>
      {mostrarCrearEditarModal && (
        <Modals.CrearEditarModal
          handleClose={e => setMostrarCrearEditarModal(false)}
          show={mostrarCrearEditarModal}
          reloadTable={tablaRef.current.reload}
          editarData={editarData.current}
        />
      )}
    </>
  )
}

export default ListaSubMediosPagoPage
